import React, { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  NavbarBrand,
  Media,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";
import Logo from "../../assets/img/custom/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/actions/authAction";
import { FaBell } from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { getUnreadNotifications } from "store/actions/notificationsAction";

const AdminNavbar = (props) => {
  let dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const { unreadNotifications } = useSelector((state) => state.notifications);
  const [showDot, setShowDot] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);

  const logoutToggle = () => {
    setLogoutModal(!logoutModal);
  };

  useEffect(() => {
    if (user?.id) {
      dispatch(getUnreadNotifications(user.id, "", () => {}));
    }
  }, []);

  useEffect(() => {
    if (
      location.pathname !== "/school/notifications" &&
      unreadNotifications?.length > 0
    ) {
      setShowDot(true);
    }
  }, [unreadNotifications, location.pathname]);

  useEffect(() => {
    if (location.pathname === "/school/notifications") {
      setShowDot(false);
    }
  }, [location.pathname]);

  const handleBellClick = () => {
    setShowDot(false);
    history.push("/school/notifications");
  };
  return (
    <>
      <Navbar
        className="navbar-top bg-white d-none d-md-flex"
        expand="md"
        id="navbar-main"
      >
        <NavbarBrand
          className="pt-0"
          href="https://fans-help-players-athlete.web.app/"
        >
          <img className="mx-2" alt={Logo} src={Logo} height="70px" />
        </NavbarBrand>
        <Container fluid className="d-flex justify-content-end">
          <div
            onClick={handleBellClick}
            className="position-relative mr-4"
            style={{ cursor: "pointer" }}
          >
            <FaBell size={24} className="text-dark" />
            {showDot && (
              <span
                className="position-absolute bg-danger rounded-circle blinking-dot"
                style={{
                  width: "10px",
                  height: "10px",
                  top: "-5px",
                  right: "-5px",
                  zIndex: 1,
                }}
              ></span>
            )}
          </div>
          <div>
            <Button className=" bg-transparent border-0" onClick={logoutToggle}>
              Logout
            </Button>
          </div>
        </Container>
      </Navbar>
      <Modal isOpen={logoutModal} centered toggle={logoutToggle}>
        <ModalBody>
          <div className="text-center">
            <br />
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to logout.
            </span>
            <br />
            <br />
            <br />
            <Button color="danger" onClick={logoutToggle}>
              Cancel
            </Button>{" "}
            <Button color="primary" onClick={() => dispatch(logout())}>
              Logout
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AdminNavbar;
